module.exports = {"220302001":"仁兴街道","220302002":"英雄街道","220302003":"站前街道","220302004":"北沟街道","220302005":"地直街道","220302200":"平西乡","220302400":"红嘴高新技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220302.json
// module id = 574
// module chunks = 0